import React from 'react';
import { proofItems } from '../data/content';
export function ProofBand() {
  return <section aria-label="Company facts" className="w-full border-b border-warm-200 bg-white" data-id="element-193" data-mp="1stbwbclf80kj">
      <div className="mx-auto grid max-w-shell grid-cols-1 divide-y divide-warm-200 px-5 md:grid-cols-3 md:divide-x md:divide-y-0 lg:grid-cols-[0.78fr_1.1fr_1.42fr] lg:px-8" data-id="element-194" data-mp="1xsybvsoq1swi">
        {proofItems.map(item => <div key={item.headline} className="py-7 md:py-9 md:pr-5 md:[&:not(:first-child)]:pl-5 lg:last:pr-0 xl:pr-7 xl:[&:not(:first-child)]:pl-7" data-id="element-195" data-mp="27re0np0a0q2u">
            <h2 className="font-display text-2xl font-semibold uppercase leading-tight tracking-[0.01em] text-ink lg:whitespace-nowrap xl:text-[26px]" data-id="element-196" data-mp="2gjg2nrpzuef8">
              {item.headline}
            </h2>
            <p className="mt-2 max-w-[22rem] text-sm leading-relaxed text-steel" data-id="element-197" data-mp="2qhm3e602deii">{item.sublabel}</p>
          </div>)}
      </div>
    </section>;
}